<template>
  <b-container>
    <b-row>
      <!-- {{ model }} -->
      <b-col>
        <a href="#" @click="openModal()" title="Localização" v-b-tooltip.hove>
          <i class="tim-icons icon-square-pin"></i>
        </a>
      </b-col>
      <b-col>
        <a
          href="#"
          @click="openCargoEditModal()"
          title="Editar carga"
          v-b-tooltip.hove
        >
          <i class="tim-icons icon-pencil"></i>
        </a>
      </b-col>
      <b-col>
        <b-col>
          <a
            href="#"
            @click="openEditModal()"
            title="Proxímo status"
            v-b-tooltip.hove
          >
            <i class="tim-icons icon-double-right"></i>
          </a>
        </b-col>
      </b-col>
      <b-col v-if="urlChecklist">
        <a :href="urlChecklist" title="Checklist" v-b-tooltip.hove>
          <i class="tim-icons icon-paper"></i>
        </a>
      </b-col>
    </b-row>
    <!-- {{urlChecklist}} -->
    <kanban-edit-modal
      ref="kanbanEditModal"
      :id="id"
      @confirmEdit="confirmEdit"
    >
    </kanban-edit-modal>
    <cargo-edit-modal
      ref="cargoEditModal"
      :id="id.toString()"
      :cargo.sync="model"
      @confirmEdit="confirmEdit"
    >
    </cargo-edit-modal>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Localização"
    >
      <!-- <div>latitude: {{ latitude }}</div> -->
      <!-- <div>longitude: {{ longitude }}</div> -->
      <!-- <div>{{ pin }}</div> -->
      <div v-if="latitude == 0 && longitude == 0">
        <h4 class="danger">Essa ocorrência não possui localização</h4>
      </div>
      <base-map :apiKey="apiKey" :pin="pin"> </base-map>
      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()"> Fechar </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "KanbanSettings",
  components: {
    BaseMap: () => import("@/components_rms/base/BaseMap.vue"),
    KanbanEditModal: () => import("./KanbanEditModal.vue"),
    CargoEditModal: () =>
      import("@/components_rms/tracking/cargo/CargoEditModal.vue"),
  },
  props: {
    latitude: Number,
    longitude: Number,
    id: Number,
    urlChecklist: String,
    item: Object,
  },
  created() {
    this.pin.location.longitude = this.longitude;
    this.pin.location.latitude = this.latitude;
  },
  data() {
    return {
      apiKey:
        "As-Vkf2McY-jBXfx3q_vrpwdrFmtyixvHjGFuv90Ak2WD338py0sIQ7wCf5z2D80", //chave da api
      pin: {
        key: "pin1",
        location: {
          latitude: 0,
          longitude: 0,
        },
        visible: true,
      },
      model: {},
    };
  },
  computed: {
    getEditUrl() {
      return `/trackingShippingCompany/cargo/edit/${this.id}`;
    },
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },

    openImage() {
      this.$refs.fullscreenSidebar.open();
    },
    openEditModal() {
      this.$refs.kanbanEditModal.show();
    },
    openChecklist() {
      this.$router.push(this.urlChecklist);
    },
    openCargoEditModal() {
      this.$refs.cargoEditModal.show();
    },
    confirmEdit() {
      this.$emit("confirmEdit");
    },
  },
  watch: {
    latitude() {
      if (this.latitude != 0) this.pin.location.latitude = this.latitude;
    },
    longitude() {
      if (this.longitude != 0) this.pin.location.longitude = this.longitude;
    },
  },
};
</script>
<style scoped>
.danger {
  color: #fd5d93 !important;
}
</style>
